import { Link } from '@/lib/router';
import { Wordmark, BRAND_ACCENT } from '../components/Wordmark';
import { AppNav } from '../components/layout/AppNav';
import { CLAUDE_INTEGRATIONS_URL, CONNECTOR_URL } from '../lib/connector';

/**
 * Shown when a confirmed-but-non-owner user hits an app route (/chat,
 * document editor, etc.). The product is the Prometheus MCP connector, not
 * the web app — so we route them to connect in Claude and to /account, and
 * keep the web client owner-only for now (CC-SPEC item 4).
 */
export function ComingSoon() {
  return (
    <main className="min-h-screen bg-surface-0 text-text-primary font-prose flex flex-col items-center justify-center px-6 py-16">
      <div className="fixed top-3 left-3 z-50">
        <AppNav />
      </div>
      <div className="w-full max-w-[560px] flex flex-col items-center text-center gap-5">
        <Wordmark size="lg" />

        <p
          className="font-ui text-xs uppercase tracking-[0.08em] font-semibold m-0"
          style={{ color: BRAND_ACCENT }}
        >
          Web app — coming soon
        </p>

        <h1 className="font-prose text-2xl font-semibold leading-tight m-0">
          Prometheus runs inside Claude.
        </h1>

        <p className="font-prose text-md text-text-secondary leading-relaxed m-0 max-w-[480px]">
          The web client isn’t open yet — the product today is the Prometheus
          MCP connector. Add it to Claude as a custom connector, then ask any
          legal question and get answers grounded in primary law with
          verifiable citations.
        </p>

        <pre className="w-full m-0 bg-surface-2 border border-border rounded-md px-4 py-3 font-mono text-sm text-text-primary overflow-x-auto text-left">
          {CONNECTOR_URL}
        </pre>

        <div className="flex flex-wrap items-center justify-center gap-3 mt-1">
          <a
            href={CLAUDE_INTEGRATIONS_URL}
            target="_blank"
            rel="noreferrer noopener"
            className="font-ui text-sm font-medium px-5 py-2.5 rounded-md text-surface-white no-underline"
            style={{ backgroundColor: BRAND_ACCENT }}
          >
            Connect in Claude
          </a>
          <Link
            to="/account"
            className="font-ui text-sm font-medium px-5 py-2.5 rounded-md border border-border text-text-secondary hover:text-text-primary hover:bg-surface-1 no-underline"
          >
            Go to your account
          </Link>
        </div>
      </div>
    </main>
  );
}
